'use strict';

var cov_1fzfb1kczn = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Heading/lib/index.js',
      hash = '61a89cb0ee0dce83443797bc4bd862cc9ddee39c',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Heading/lib/index.js',
    statementMap: {
      '0': {
        start: {
          line: 7,
          column: 17
        },
        end: {
          line: 7,
          column: 64
        }
      },
      '1': {
        start: {
          line: 7,
          column: 32
        },
        end: {
          line: 7,
          column: 64
        }
      },
      '2': {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 23,
          column: 1
        }
      },
      '3': {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 20,
          column: 35
        }
      },
      '4': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 96
        }
      },
      '5': {
        start: {
          line: 25,
          column: 16
        },
        end: {
          line: 29,
          column: 1
        }
      },
      '6': {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 51
        }
      },
      '7': {
        start: {
          line: 31,
          column: 0
        },
        end: {
          line: 31,
          column: 74
        }
      },
      '8': {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 33,
          column: 36
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 18
          }
        },
        loc: {
          start: {
            line: 7,
            column: 32
          },
          end: {
            line: 7,
            column: 64
          }
        },
        line: 7
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 18,
            column: 11
          },
          end: {
            line: 18,
            column: 12
          }
        },
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 20,
            column: 35
          }
        },
        line: 19
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 21,
            column: 22
          },
          end: {
            line: 21,
            column: 23
          }
        },
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 96
          }
        },
        line: 22
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 24
          }
        },
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 51
          }
        },
        line: 26
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 20,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 19,
            column: 5
          },
          end: {
            line: 19,
            column: 16
          }
        }, {
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 39
          }
        }, {
          start: {
            line: 19,
            column: 43
          },
          end: {
            line: 19,
            column: 72
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 35
          }
        }],
        line: 19
      },
      '1': {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 96
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 22,
            column: 5
          },
          end: {
            line: 22,
            column: 16
          }
        }, {
          start: {
            line: 22,
            column: 20
          },
          end: {
            line: 22,
            column: 39
          }
        }, {
          start: {
            line: 22,
            column: 43
          },
          end: {
            line: 22,
            column: 78
          }
        }, {
          start: {
            line: 22,
            column: 83
          },
          end: {
            line: 22,
            column: 96
          }
        }],
        line: 22
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0, 0, 0],
      '1': [0, 0, 0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  box-sizing: border-box;\n  font-weight: 500;\n  display: inline-block;\n  font-size: ', ';\n  margin: 0;\n  margin-top: 0.85714em;\n  margin-bottom: 0.57142em;\n  color: ', ';\n  background-color: ', ';\n'], ['\n  position: relative;\n  box-sizing: border-box;\n  font-weight: 500;\n  display: inline-block;\n  font-size: ', ';\n  margin: 0;\n  margin-top: 0.85714em;\n  margin-bottom: 0.57142em;\n  color: ', ';\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  ', ';\n'], ['\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _stylingConstants = require('@gravity/styling-constants');

var _stylingConstants2 = _interopRequireDefault(_stylingConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cov_1fzfb1kczn.s[0]++;


var fontSize = function fontSize(_ref) {
  var level = _ref.level;
  cov_1fzfb1kczn.f[0]++;
  cov_1fzfb1kczn.s[1]++;
  return (0.875 + 3) * (1 / level) + 'em';
};

var styles = (cov_1fzfb1kczn.s[2]++, (0, _styledComponents.css)(_templateObject, fontSize, function (props) {
  cov_1fzfb1kczn.f[1]++;
  cov_1fzfb1kczn.s[3]++;
  return (cov_1fzfb1kczn.b[0][0]++, props.theme) && (cov_1fzfb1kczn.b[0][1]++, props.theme.heading) && (cov_1fzfb1kczn.b[0][2]++, props.theme.heading.textColor) || (cov_1fzfb1kczn.b[0][3]++, _stylingConstants2.default.color.baseText);
}, function (props) {
  cov_1fzfb1kczn.f[2]++;
  cov_1fzfb1kczn.s[4]++;
  return (cov_1fzfb1kczn.b[1][0]++, props.theme) && (cov_1fzfb1kczn.b[1][1]++, props.theme.heading) && (cov_1fzfb1kczn.b[1][2]++, props.theme.heading.backgroundColor) || (cov_1fzfb1kczn.b[1][3]++, 'transparent');
}));

var Heading = (cov_1fzfb1kczn.s[5]++, (0, _styledComponents2.default)(function (_ref2) {
  var level = _ref2.level,
      children = _ref2.children,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['level', 'children']);
  cov_1fzfb1kczn.f[3]++;
  cov_1fzfb1kczn.s[6]++;
  return _react2.default.createElement('h' + level, props, children);
})(_templateObject2, styles));

cov_1fzfb1kczn.s[7]++;
Heading.propTypes = { level: _propTypes2.default.number, children: _propTypes2.default.node };

cov_1fzfb1kczn.s[8]++;
Heading.defaultProps = { level: 1 };

exports.default = Heading;